@media (min-width: 576px) {
  task-selector .infopanel {
    position: absolute;
    top: 0;
    right: 0;
    width: 300px;
    height: 100%;
    background-color: #1C1C1C;
  }
}

@media (max-width: 575.98px) {
  task-selector .infopanel {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #1C1C1C;
    z-index: 9999;
  }
}

.link-button {
  --color: var(--ion-text-color);
  text-decoration: underline;
  padding: 0;
  height: auto;
  min-height: unset;
  font-size: inherit;
  text-transform: none;
  font-weight: normal;
}